// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"14105a7b","457":"49cc088b","828":"6e396f19"}[chunkId] + ".chunk.js";
};